import { createSlice } from "@reduxjs/toolkit";
import { IDriver } from "Shared/Types/driver";
import { createDriver, getDriver, getDriverList } from "./reducer";
import { RootState } from "Redux/store";

interface IDriverState {
  driverList?: IDriver[] | null;
  error?: string | null;
  loading: boolean;
  currentDriver?: IDriver | null;
}

const initialState: IDriverState = {
  driverList: null,
  currentDriver: null,
  loading: false,
  error: null,
};

const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    resetDrivers: (state) => {
      state.driverList = [];
      state.currentDriver = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDriverList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDriverList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getDriverList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.driverList = action.payload;
    });

    builder.addCase(getDriver.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDriver.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getDriver.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentDriver = action.payload;
    });

    builder.addCase(createDriver.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createDriver.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(createDriver.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.driverList = [action.payload, ...(state.driverList || [])];
    });
  },
});

export const { resetDrivers } = driverSlice.actions;

export const selectDriverLoading = (state: RootState) => state.driver.loading;
export const selectDriverList = (state: RootState) => state.driver.driverList;
export const selectDriverError = (state: RootState) => state.driver.error;
export const selectCurrentDriver = (state: RootState) =>
  state.driver.currentDriver;

export default driverSlice;
